// /src/components/common/utils/filters/secondConversions.js
const pad = function(num) {
  return ('0' + num).slice(-2)
}
export default {
  hhmmss: secs => {
    let minutes = Math.floor(secs / 60)
    secs = secs % 60
    const hours = Math.floor(minutes / 60)
    minutes = minutes % 60
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
  },
  mm: secs => {
    return Math.ceil(secs / 60) % 60
  },
}
